import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@material-ui/core';
import { useFormik } from 'formik';
import React, { useCallback, useContext, useEffect } from 'react';
import * as yup from 'yup';
import { TablaGruposContablesContext } from './tablaGruposContables';

const validationSchema = yup.object({
  nombre: yup.string().required(),
  grupo: yup.string().required(),
  sigla: yup.string().required(),
});

export default function DialogoCRUDGrupoContable() {
  const { openDialogoCRUD, setOpenDialogoCRUD, tituloDialogo, handleAceptar, disableEditing, initialValues } =
    useContext(TablaGruposContablesContext);

  const handleClose = () => setOpenDialogoCRUD(false);

  const formik = useFormik({
    initialValues,
    onSubmit: handleAceptar,
    validationSchema,
  });

  const { values, errors, touched, handleSubmit, handleChange, resetForm } = formik;

  const resetFormik = useCallback(() => {
    resetForm({ values: initialValues });
  }, [initialValues, resetForm]);

  useEffect(() => {
    resetFormik();
  }, [resetFormik]);

  return (
    <Dialog open={openDialogoCRUD} maxWidth="md" fullWidth>
      <DialogTitle>{tituloDialogo}</DialogTitle>
      <form autoComplete="off" onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs>
              <TextField
                label="Nombre"
                name="nombre"
                value={values.nombre}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                disabled={disableEditing}
                error={errors.nombre && touched.nombre ? true : false}
                helperText={errors.nombre && touched.nombre ? errors.nombre : ''}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs>
              <TextField
                label="Grupo"
                name="grupo"
                value={values.grupo}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                disabled={disableEditing}
                error={errors.grupo && touched.grupo ? true : false}
                helperText={errors.grupo && touched.grupo ? errors.grupo : ''}
              />
            </Grid>
            <Grid item xs>
              <TextField
                label="Sigla"
                name="sigla"
                value={values.sigla}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                disabled={disableEditing}
                error={errors.sigla && touched.sigla ? true : false}
                helperText={errors.sigla && touched.sigla ? errors.sigla : ''}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="primary">
            Cancelar
          </Button>
          <Button type="submit" variant="contained" color="primary">
            Aceptar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
